import { useState, useEffect } from 'react';

const EXIT_INTENT_KEY = 'raven-moon-exit-intent-shown';
const ANY_POPUP_KEY = 'raven-moon-any-popup-shown';

export function useExitIntent() {
  const [showExitPopup, setShowExitPopup] = useState(false);

  useEffect(() => {
    // Don't show if any popup was already shown this session
    if (sessionStorage.getItem(ANY_POPUP_KEY)) return;
    if (sessionStorage.getItem(EXIT_INTENT_KEY)) return;

    const handleMouseLeave = (e: MouseEvent) => {
      if (e.clientY <= 5 && e.relatedTarget === null) {
        // Don't show if any popup already fired
        if (sessionStorage.getItem(ANY_POPUP_KEY)) return;

        setShowExitPopup(true);
        sessionStorage.setItem(EXIT_INTENT_KEY, 'true');
        sessionStorage.setItem(ANY_POPUP_KEY, 'true');
      }
    };

    const timeout = setTimeout(() => {
      document.addEventListener('mouseleave', handleMouseLeave);
    }, 5000);

    return () => {
      clearTimeout(timeout);
      document.removeEventListener('mouseleave', handleMouseLeave);
    };
  }, []);

  const closeExitPopup = () => {
    setShowExitPopup(false);
  };

  return { showExitPopup, closeExitPopup };
}
